<template>
	<div>
		<div v-if="projectId" style="margin-top: 20px;">
			<div style="margin-bottom: 20px;margin-left:12%;border-radius: 20px;background-color: #fdf6ec;color: red;font-size: 20px;height: 160px;width: 80%;display:flex;align-items: center;text-align: center;">
				<div style="padding-left: 10%;text-align: left">
					<div>
						上传图纸说明：
					</div>
					<!-- <div>
						1、图纸来源：可通过联系开发商、物业公司、装修公司获得相应图纸
					</div> -->
					<div>
						1、图纸要求：点击下载“ <span  @click="drawingStandard" style="font-size: 16px ;color: rgb(78,161,248)">图纸要求说明.docx</span>”查阅参考
					</div>
					<div style='margin-bottom: 0;padding-bottom: 0'>
						2、图纸转换：点击下载“ <span  @click="cadExport" style="font-size: 16px;color: rgb(78,161,248)">CAD图纸导出PDF格式操作说明.mp4</span>”查阅参考
					</div>
					<div style="margin-top: 0;padding-top: 0">
						3、图纸样例：点击下载“ <span  @click="drawingExport" style="font-size: 16px ;color: rgb(78,161,248)">全套图纸样例.zip</span>”，“ <span  @click="drawingExport2" style="font-size: 16px ;color: rgb(78,161,248)">全套图纸样例2.zip</span>”查阅参考
					</div>
				</div>
			</div>
			<div v-for="item in fileList" :key="item.name" style="width: 90%;margin: 0 auto;">
				<div style="display: flex; justify-content: flex-start; align-items: center;margin-bottom: 10px;border-bottom: 2px solid #4392F4;padding-bottom: 10px">
					<div style="font-size: 24px;font-weight: bold;">{{ item.name }}</div>
					<el-popover
							placement="right"
							width="500"
							trigger="click"
							popper-class="popperClass"
							v-if="item.name !== '灭火器'&&item.name !== '其他'"
					>
						<div style="font-size: 22px">{{ item.remark }}</div>
						<el-button slot="reference"  class="circle-button" type="text" >？</el-button>
					</el-popover>
				</div>
				<div v-for="ite in item.data" :key="ite.title" >
					<div class="itemList">
						<div style="font-size: 18px;padding-left: 10px"><span style="color: red;">{{ite.isXing?'*':undefined}}</span>{{ ite.title }}{{cityCode === '430100'&&ite.title ==='总平面图'?'不含主体工程（局部室内装修）项目可仅提供竣工整层平面图、防火分区图':undefined}}</div>
						<!--					<el-button style="margin-right: 20px" type="primary" size="mini" @click="addSheet(ite)">{{ ite.button }}</el-button>-->
						<div style="display: flex;justify-content: flex-end;align-items: center;padding-right: 30px ">							
							<input v-if="!butISdisabled" type="file"
							       accept=".pdf"
							       style='font-size: 16px;width: 20%;'
							       multiple
							       @change="handleFileUpload($event, ite, item)"
							       /> <!-- 文件选择控件，传递额外参数 -->
							<el-button type="primary" v-if="!butISdisabled" size="mini" @click="showSplitFiles(ite)">选择图纸</el-button>
							
							<div style="width: 80px;margin-left: 30px">
								<el-button v-if="ite.drawingUrl"  type="text" @click="downloadPdf(ite)">样例</el-button>
								<el-button v-if="ite.drawingUrlOne" type="text" @click="downloadPdfOne(ite)">样例</el-button>
							</div>
						</div>
					
					</div>
					<div v-for="child in ite.childFiles" class="fileListItem">
						<div>
							<el-button type="text" size="mini" @click="downloadDrawing(child)">{{ child.fileName }}</el-button>
						</div>
						<div>
							
							<el-button type="text" size="mini" @click="downloadDrawing(child)">浏览</el-button>
							<el-button v-if="!butISdisabled" type="text" size="mini" @click="deleteDrawing(child)">删除</el-button>
						</div>
					</div>
				</div>
			</div>
			<el-dialog
					title="图纸预览"
					:visible.sync="drawingDialog"
					v-model="drawingDialog"
					:modal="false"
					:append-to-body="true"
					width='60%'
					:fullscreen="true"
			>
				<iframe
						style="width: 100%;height: 100vh"
						:src="drawingUrl"
				></iframe>
			</el-dialog>
			<el-dialog
					title="上传图纸"
					:visible.sync="drawingDialog"
					v-model="drawingDialog"
					:modal="false"
					:append-to-body="true"
					width='60%'
					:fullscreen="true"
			>
				<iframe
						style="width: 100%;height: 100vh"
						:src="drawingUrl"
				></iframe>
			</el-dialog>
			<!-- 添加分页文件选择弹窗 -->
			<el-dialog
					title="选择图纸"
					:visible.sync="splitFileDialogVisible"
					v-model="splitFileDialogVisible"
					:modal="false"
					
					width="40%">
				<el-table
			    ref="multipleTable"
			    :data="selectedSplitFiles"
			    tooltip-effect="dark"
			    style="width: 100%;"
			    max-height="600"
			    @selection-change="handleSelectionChange">
			    <el-table-column
			        type="selection"
			        width="55">
			    </el-table-column>
						   <!-- 修改分页文件选择弹窗中的表格列 -->
					<el-table-column
					    label="预览"
					    width="150">
					    <template slot-scope="scope">
					        <img
					            :src="scope.row.imageUrl"
					            style="width: 100px;  object-fit: contain; border: 1px solid #ddd; cursor: pointer;"
					            @click="previewImage(scope.row.imageUrl)"
					        />
					    </template>
					</el-table-column>



			    <el-table-column
			        label="文件名称"
			        width="">
			        <template slot-scope="scope">{{ scope.row.name }}</template>
			    </el-table-column>
			</el-table>

				<span slot="footer" class="dialog-footer">
		      <el-button @click="splitFileDialogVisible = false">取 消</el-button>
		      <el-button type="primary" @click="confirmSelectSplitFiles">确 定</el-button>
		    </span>
			</el-dialog>
			
			<!-- 在分页文件选择弹窗后面添加图片预览弹窗 -->
						<!-- 修改图片预览弹窗 -->
			<el-dialog
			    title="图纸缩略图"
			    :visible.sync="imagePreviewDialogVisible"
			    v-model="imagePreviewDialogVisible"
			    :modal="true"
			    width="80%"
			    :append-to-body="true">
			    <div style="text-align: center; padding: 20px;">
			        <img :src="previewImageUrl" style="width: 100%;  object-fit: contain;" />
			    </div>
			    <span slot="footer" class="dialog-footer">
			        <el-button @click="imagePreviewDialogVisible = false">关 闭</el-button>
			    </span>
			</el-dialog>

			
					</div>
					<div v-else style="width: 100%;margin: 10% auto;">
						<div style="text-align: center">
							{{'请先填写申报表后在添加图纸！'}}
						</div>
					</div>
				</div>
			</template>
			
			
			<script>
			import util from "../../../util/date";
			import {
				getKYJCProjectFileInfo,
				addKYJCProjectFile,
				deleteKYJCProjectFile,
				generateTemporaryUrl,
				generateTemporaryUrlByFileName,
				getKYJCApplicationByProjectId
			} from '../../api/api'

			import ObsClient from 'esdk-obs-browserjs/src/obs'
			import SparkMD5 from'spark-md5';
			import { PDFDocument } from "pdf-lib";
			import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
			import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'
			
			// 配置pdfjs工作器
			pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker
			
			function debounce(fn, delay) {
				let timer = null;
				return function (...args) {
					if (timer) clearTimeout(timer);
					timer = setTimeout(() => fn.apply(this, args), delay);
				};
			}
			
			export default {
			    components:{},
			    data() {
			        return {
				        imagePreviewDialogVisible: false,
				        previewImageUrl: '',
								url:'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
				        drawingDialog:false,
								fileInfo:[],
				        defaultProps: {
					        children: 'childFiles',
					        label: 'fileName',
				        },
				        fileList:[
					        {
						        name: '场所平面结构图',
						        remark:'包括场地四邻原有及规划道路的位置和主要建筑物及构筑物的位置、名称、功能、层数、间距;场所所在建筑物的位置、名称、层数和消防车道及登高操作场地布置等内容；包括场所平面布置，房间功能和面积，疏散楼梯、疏散走道，消防电梯，平面或空间的防火、防烟分区面积、分隔位置和分隔物；各部位(顶棚、墙面、地面、隔断的装修材料以及固定家具、装饰织物、其他装饰等)装修材料燃烧性能等内容。',
						        data:[
							        {
								        title:'消防设计说明（图纸设计说明以合并方式书写的可重复上传）',
								        id:20,
								        isXing:false,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%80%BB%E5%B9%B3%E9%9D%A2%E5%9B%BE/%E6%B6%88%E9%98%B2%E8%AE%BE%E8%AE%A1%E8%AF%B4%E6%98%8E.pdf',
							        },
							        {
								        title:'总平面图',
								        isXing:false,
								        id:1,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%80%BB%E5%B9%B3%E9%9D%A2%E5%9B%BE/%E6%80%BB%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
							        },
							        {
								        title:'楼层平面布置图',
								        isXing:false,
								        id:2,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%A5%BC%E5%B1%82%E5%B9%B3%E9%9D%A2%E5%B8%83%E7%BD%AE%E5%9B%BE/%E9%A6%96%E5%B1%82%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
							        },
							        {
								        title:'场所平面布置图',
								        isXing:false,
								        id:28,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%A5%BC%E5%B1%82%E5%B9%B3%E9%9D%A2%E5%B8%83%E7%BD%AE%E5%9B%BE/%E5%B9%B3%E9%9D%A2%E5%B8%83%E7%BD%AE%E5%9B%BE.pdf',
							        },
							        {
								        title:'顶棚装修平面图',
								        isXing:false,
								        id:25,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E8%A3%85%E4%BF%AE%E5%9B%BE/%E9%A1%B6%E6%A3%9A%E8%A3%85%E4%BF%AE%E5%9B%BE.pdf',
							        },
							        {
								        title:'墙面装修平面图',
								        isXing:false,
								        id:27,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E8%A3%85%E4%BF%AE%E5%9B%BE/%E7%AB%8B%E9%9D%A2%E8%A3%85%E4%BF%AE%E5%9B%BE.pdf',
							        },
							        {
								        title:'地面装修平面图',
								        isXing:false,
								        id:26,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E8%A3%85%E4%BF%AE%E5%9B%BE/%E5%9C%B0%E9%9D%A2%E8%A3%85%E4%BF%AE%E5%9B%BE.pdf',
							        },
						        ]
					        },
					        {
						        name: '消防电源及配电',
						        remark:'包括消防供电负荷等级，消防配电线路的敷设方式，备用消防电源的供电时间和容量；包括消防应急照明和疏散指示的系统方式，配电方式及供电时间，灯具选型，照度、安装位置和高度，线路敷设方式等。',
						        data:[
							        {
								        title:'消防电气设计说明（图纸设计说明以合并方式书写的可重复上传）',
								        isXing:false,
								        id:21,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%94%B5%E6%BA%90%E5%8F%8A%E9%85%8D%E7%94%B5/%E7%94%B5%E6%B0%94%E8%AE%BE%E8%AE%A1%E8%AF%B4%E6%98%8E.pdf',
							        },
							        {
								        title:'消防配电平面图、系统图',
								        isXing:false,
								        id:3,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%94%B5%E6%BA%90%E5%8F%8A%E9%85%8D%E7%94%B5/%E6%B6%88%E9%98%B2%E7%94%B5%E6%B0%94%E7%B3%BB%E7%BB%9F%E5%9B%BE.pdf',
							        },
							        {
								        title:'应急照明和疏散指示平面图、系统图',
								        isXing:false,
								        id:4,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%94%B5%E6%BA%90%E5%8F%8A%E9%85%8D%E7%94%B5/%E5%BA%94%E6%80%A5%E7%85%A7%E6%98%8E%E5%92%8C%E7%96%8F%E6%95%A3%E6%8C%87%E7%A4%BA%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
								        drawingUrlOne:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%94%B5%E6%BA%90%E5%8F%8A%E9%85%8D%E7%94%B5/%E5%BA%94%E6%80%A5%E7%85%A7%E6%98%8E%E5%92%8C%E7%96%8F%E6%95%A3%E6%8C%87%E7%A4%BA%E7%B3%BB%E7%BB%9F%E5%9B%BE.pdf'
							        }
						        ]
					        },
					        {
						        name: '火灾自动报警系统',
						        remark:'包括系统形式，线路的敷设方式，火灾探测器的类型及位置，手动报警按钮、消火栓启泵按钮、消防电话、火灾应急广播及消防联动控制设备位置等内容。',
						        data:[
							        {
								        title:'消防电气设计说明（图纸设计说明以合并方式书写的可重复上传）',
								        isXing:false,
								        id:22,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'',
							        },
							        {
								        title:'消防控制室位置平面图',
								        isXing:false,
								        id:5,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F/%E6%B6%88%E9%98%B2%E6%8E%A7%E5%88%B6%E5%AE%A4%E4%BD%8D%E7%BD%AE%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
							        },
							        {
								        title:'火灾自动报警系统图、各层报警平面图',
								        isXing:false,
								        id:6,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
								        drawingUrlOne:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F%E7%B3%BB%E7%BB%9F%E5%9B%BE.pdf',
							        },
							        {
								        title:'可燃气体探测报警系统平面图、系统图',
								        isXing:false,
								        id:7,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F%E5%B9%B3%E9%9D%A2%E5%9B%BE-%E5%8F%AF%E7%87%83%E6%B0%94%E4%BD%93.pdf',
							        },
							        {
								        title:'电气火灾监控系统平面图、系统图',
								        isXing:false,
								        id:8,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F%E7%B3%BB%E7%BB%9F%E5%9B%BE-%E9%9F%B3%E8%A7%86%E9%A2%91%E8%AD%A6%E6%8A%A5%E3%80%81%E7%94%B5%E6%B0%94%E7%81%AB%E7%81%BE%E7%9B%91%E6%8E%A7.pdf',
							        },
							        {
								        title:'防火门监控系统平面图、系统图',
								        isXing:false,
								        id:9,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'',
							        },
							        {
								        title:'消防设备电源监控系统图',
								        isXing:false,
								        id:10,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'',
							        },
						        ]
					        },
					        {
						        name: '消防给水和灭火设施',
						        remark:'包括消防水源的供水方式，消防水泵房、消防水池、水泵接合器位置，室外消防给水系统给水管道及室外消火布置；包括室内消火栓系统给水管道及消火栓的布置；包括系统组成、控制方式，报警阀、末端试水装置位置；包括系统组成、控制方式，储瓶间位置',
						        data:[
							        {
								        title:'消防给排水设计说明（图纸设计说明以合并方式书写的可重复上传）',
								        isXing:false,
								        id:23,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%BB%99%E6%B0%B4%E5%92%8C%E7%81%AD%E7%81%AB%E8%AE%BE%E6%96%BD/%E6%B6%88%E9%98%B2%E7%BB%99%E6%B0%B4%E5%92%8C%E7%81%AD%E7%81%AB%E8%AE%BE%E6%96%BD%E8%AE%BE%E8%AE%A1%E8%AF%B4%E6%98%8E.pdf',
							        },
							        {
								        title:'消防给水总平面图，各消防给水系统的平面图、系统图',
								        isXing:false,
								        id:11,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%BB%99%E6%B0%B4%E5%92%8C%E7%81%AD%E7%81%AB%E8%AE%BE%E6%96%BD/%E6%B6%88%E9%98%B2%E7%BB%99%E6%B0%B4%E5%92%8C%E7%81%AD%E7%81%AB%E8%AE%BE%E6%96%BD%E7%B3%BB%E7%BB%9F%E5%9B%BE.pdf',
							        },
							        {
								        title:'消防水池和消防水泵房平面图',
								        isXing:false,
								        id:12,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%BB%99%E6%B0%B4%E5%92%8C%E7%81%AD%E7%81%AB%E8%AE%BE%E6%96%BD/%E6%B6%88%E9%98%B2%E6%B0%B4%E6%B3%B5%E6%88%BF%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
							        },
							        {
								        title:'室内消火栓系统图、各层平面图',
								        isXing:false,
								        id:13,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%BB%99%E6%B0%B4%E5%92%8C%E7%81%AD%E7%81%AB%E8%AE%BE%E6%96%BD/%E5%AE%A4%E5%86%85%E6%B6%88%E7%81%AB%E6%A0%93%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
							        },
							        {
								        title:'自动喷水灭火系统的平面图、系统图',
								        isXing:false,
								        id:14,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%BB%99%E6%B0%B4%E5%92%8C%E7%81%AD%E7%81%AB%E8%AE%BE%E6%96%BD/%E8%87%AA%E5%8A%A8%E5%96%B7%E6%B0%B4%E7%81%AD%E7%81%AB%E7%B3%BB%E7%BB%9F%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
							        },
							        {
								        title:'气体灭火系统的平面图、系统图',
								        isXing:false,
								        id:15,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'',
							        },
							        {
								        title:'灭火器配置平面',
								        isXing:false,
								        id:18,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%BB%99%E6%B0%B4%E5%92%8C%E7%81%AD%E7%81%AB%E8%AE%BE%E6%96%BD/%E7%81%AD%E7%81%AB%E5%99%A8%E9%85%8D%E7%BD%AE%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
							        },],
					        },
					        {
						        name: '防烟排烟及供暖、通风和空气调节设施',
						        remark:'包括设置防烟的区域及方式，送风口以及防火阀的位置；供暖、通风和空气调节设施的防火措施；包括设置排烟的区域及方式，送风口、排烟口以及防火阀、排烟防火阀的位置；供暖、通风和空气调节设施的防火措施。',
						        data:[
							        {
								        title:'消防防排烟、暖通设计说明（图纸设计说明以合并方式书写的可重复上传）',
								        isXing:false,
								        id:24,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'',
							        },
							        {
								        title:'防烟系统平面图、系统图（防、排烟系统以合并方式作图的可重复上传）',
								        isXing:false,
								        id:16,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E9%98%B2%E7%83%9F%E6%8E%92%E7%83%9F%E5%8F%8A%E4%BE%9B%E6%9A%96%E3%80%81%E9%80%9A%E9%A3%8E%E5%92%8C%E7%A9%BA%E6%B0%94%E8%B0%83%E8%8A%82%E8%AE%BE%E6%96%BD/%E9%98%B2%E6%8E%92%E7%83%9F%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
							        },
							        {
								        title:'排烟系统平面图、系统图（防、排烟系统以合并方式作图的可重复上传）',
								        isXing:false,
								        id:17,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E9%98%B2%E7%83%9F%E6%8E%92%E7%83%9F%E5%8F%8A%E4%BE%9B%E6%9A%96%E3%80%81%E9%80%9A%E9%A3%8E%E5%92%8C%E7%A9%BA%E6%B0%94%E8%B0%83%E8%8A%82%E8%AE%BE%E6%96%BD/%E6%9C%BA%E6%A2%B0%E6%8E%92%E7%83%9F%E7%B3%BB%E7%BB%9F%E5%9B%BE.pdf',
							        }
						        ]
					        },
					        {
						        name: '其他',
						        remark:'包括系统组成、控制方式',
						        data:[
							        {
								        title:'其他',
								        isXing:false,
								        id:19,
								        button:'上传图纸',
								        childFiles:[],
								        drawingUrl:'',
							        },
						        ]
					        },
				        ],
				        Bucket: process.env.VUE_APP_BUCKET_NAME,  // 存储桶名称
				        obsClient: null,  // 初始化OBS客户端
				        uploading: false, // 上传状态
				        Area:  process.env.VUE_APP_SERVER_ACCESS_AREA_A,    // 区域名称
				        keyValue:'',
				        drawingUrl:'',
				        drawingList:[],
				        vLoading:false,
				        placeJsonData:[],
				        count:0,
				        countFile:0,
				        itemName:'',
				        fileMd:'',
				        splitFileDialogVisible: false,
				        selectedSplitFiles: [],
				        isAllFile:false,
				        sessionFiles: [],
				        currentFileForSplit: null,
				        splitFiles: [], // 存储真实分割后的PDF文件（含File对象、页码、选中状态）
				        pdfProcessing: false, // PDF处理中标记（防止重复操作）
				        additionalData:undefined,
				        selectFiles:undefined,
				        selectDeleteFiles:[],
				        historyFiles:undefined,
						project:{},
			        }
			    },
			    props:['projectId','cityCode','butISdisabled','tableForm'],
			    methods: {
				    // 图片预览方法
				    previewImage(imageUrl) {
					    this.previewImageUrl = imageUrl;
					    this.imagePreviewDialogVisible = true;
				    },
	    handleSelectionChange(val) {
		    console.log(val,'valduoxuan dddddddddddddd')
		    this.selectFiles = val
	    },
	    // 显示分页文件
	    showSplitFiles(item) {
		    this.additionalData = item
		    if(this.selectFiles&&this.selectFiles.length>0){
			    this.$refs.multipleTable.clearSelection();
		    }
		    // 模拟分页文件数据（实际项目中需要根据PDF文件生成）
		    this.initFormData()
		    this.splitFileDialogVisible = true;
	    },
	  // 修改 splitPdf 方法中的缩略图生成部分
async splitPdf(pdfBlob, originalFileName,files, additionalData) {
	const loading = this.$loading({
		lock: true,
		text: '分析中...',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.7)'
	});
	
	const Key = 'projectFile' + '/' + this.project.projectName + this.project.projectNo + '/' + this.fileInfo[0].stageId + '/' + this.fileInfo[0].childFiles[0].fileName + '/' +
			this.fileInfo[0].childFiles[0].childFiles[0].fileName +  '/' + pdfBlob.name; // 使用文件名作为上传的Key
	console.log(Key, 'Keyjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjj')
	await  this.uploadFileAll(files,pdfBlob, Key, additionalData);
	
    try {
        this.pdfProcessing = true;
        // 1. 加载PDF文档（转换为ArrayBuffer）
        const pdfDoc = await PDFDocument.load(await pdfBlob.arrayBuffer());
        const pageCount = pdfDoc.getPageCount();
        const splitFileList = [];
        
        if (pageCount === 0) {
            this.$message.error('PDF文件无有效页面');
            return [];
        }
        
        // 2. 循环分割每一页，生成独立PDF
        for (let i = 0; i < pageCount; i++) {
            // 创建新PDF文档
            const newPdfDoc = await PDFDocument.create();
            // 复制当前页（pdf-lib页码从0开始，需转成1-based显示）
            const [page] = await newPdfDoc.copyPages(pdfDoc, [i]);
            newPdfDoc.addPage(page);
            
            // 3. 保存为Blob并转换为File对象
            const pdfBytes = await newPdfDoc.save();
            const newBlob = new Blob([pdfBytes], { type: 'application/pdf' });
            // 文件名格式：原文件名_第X页.pdf（去除原后缀）
            const baseName = originalFileName.replace(/\.[^/.]+$/, "");
            const newFileName = `${baseName}_第${i + 1}页.pdf`;
            
            // 4. 生成高质量缩略图
            let imageUrl = '';
            try {
                // 将Blob转换为ArrayBuffer用于pdf.js
                const arrayBuffer = await newBlob.arrayBuffer();
                const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
                const pdf = await loadingTask.promise;
                const page = await pdf.getPage(1); // 每个分割后的PDF只有一页
                
                // 设置更高的缩略图尺寸（提高到300px宽度）
                const viewport = page.getViewport({ scale: 1.0 });
                const scale = 1800 / viewport.width; // 提高到300px宽度
                const scaledViewport = page.getViewport({ scale: scale });
                
                // 创建canvas渲染页面
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                canvas.height = scaledViewport.height;
                canvas.width = scaledViewport.width;
                
                // 渲染页面到canvas
                const renderContext = {
                    canvasContext: context,
                    viewport: scaledViewport
                };
                await page.render(renderContext).promise;
                
                // 转换为图片URL
                imageUrl = canvas.toDataURL('image/png');
            } catch (renderError) {
                console.error('生成缩略图失败:', renderError);
                // 如果生成失败，使用默认占位图
                imageUrl = `https://via.placeholder.com/300x400/cccccc/000000?text=第${i + 1}页`;
            }
            
            splitFileList.push({
                name: newFileName,
                selected: false,
                page: i + 1, // 1-based页码
                file: new File([newBlob], newFileName, { type: 'application/pdf' }), // 真实文件对象
                imageUrl: imageUrl // 添加缩略图URL
            });
        }
		    
        this.pdfProcessing = false;
				loading.close();
        return splitFileList;
    } catch (error) {
        this.pdfProcessing = false;
        console.error('PDF分割失败:', error);
        this.$message.error(`PDF分割出错：${error.message}`);
				loading.close()
        return [];
    }
},


	    async confirmSelectSplitFiles() {
		    if (this.isAllFile){
					this.$message({
						type: 'error',
						message: '正在上传整体文件，请稍后！',
					});
					return;
		    }
				this.splitFileDialogVisible = false;
		    this.count = 0
		    const additionalData = this.additionalData
		    // console.log(event,'ebeekljedklfjsdkf')
		    const files = this.selectFiles; // 获取选择的文件
		    
		    
		    // window.localStorage.removeItem('selectedSplitFiles')
		    // this.selectedSplitFiles = this.selectedSplitFiles.filter(file => !this.selectFiles.includes( file))
		    // this.selectDeleteFiles.push(...this.selectFiles)
		    
		    
		    // this.sessionFiles = this.selectedSplitFiles
		    // if (this.selectedSplitFiles&&this.selectedSplitFiles.length>0){
			  //   window.localStorage.setItem('selectedSplitFiles', JSON.stringify(this.selectedSplitFiles));
			  //   // window.sessionStorage.setItem('sessionFiles',JSON.stringify(this.selectedSplitFiles))
		    // }
		    files.forEach(file => {
			    setTimeout(async () => {
				    if (file.file) {
					    
						    console.log(file.file, 'file')
						    if (!this.vLoading) {
							    
							    if ( [21,3,4].includes(additionalData.id)){
								    this.itemName = '消防电源及配电'
							    }
							    if ( [22,5,6,7,8,9,10].includes(additionalData.id)){
								    this.itemName = '火灾自动报警系统'
							    }
							    if ( [23,11,12,13,14,15,18].includes(additionalData.id)){
								    this.itemName = '消防给水和灭火设施'
							    }
							    if ( [24,16,17].includes(additionalData.id)){
								    this.itemName = '防烟排烟及供暖、通风和空气调节设施'
							    }
							    if ( [1,2,20,25,26,27,28].includes(additionalData.id)){
								    this.itemName = '建筑'
							    }
							    if ( [19].includes(additionalData.id)){
								    this.itemName = '装修'
							    }
							    
							    
							    const Key = 'projectFile' + '/' + this.project.projectName + this.project.projectNo + '/' + this.fileInfo[0].stageId + '/' + this.fileInfo[0].childFiles[0].fileName + '/' +
									    this.fileInfo[0].childFiles[0].childFiles[0].fileName + '/' +this.itemName + '/' + file.name; // 使用文件名作为上传的Key
							    console.log(Key, 'Key')
							    console.log(additionalData,'additionalDataiiiiiiii')
							   
							    this.uploadFile(files,file.file, Key, additionalData); // 调用上传方法，并传递额外参数 this.uploadFile(file, Key, additionalData); // 调用上传方法，并传递额外参数
							    // }
						    }
					    }
					    
				    
			    },0)
			    
		    });
	    },
	    
	    
	    handleFileMdfive(file) {
		    const reader = new FileReader();
		    reader.readAsArrayBuffer(file);
		    reader.onload = (e) => {
			    const buffer = e.target.result;
			    const spark = new SparkMD5.ArrayBuffer();
			    spark.append(buffer);
			    const md5 = spark.end();
			    console.log('文件的MD5值为:', md5);
					this.fileMd = md5;
		    };
		    reader.onerror = (error) => {
			    console.error('文件读取错误:', error);
		    };
	    },
	    downloadPdf(value){
		    console.log(value,'valuefilepdf')
				if (value.drawingUrl){
					window.open(value.drawingUrl);
				}else{
					this.$message.error('暂无图纸');
				}
		   
	    },
	    downloadPdfOne(value){
		    if (value.drawingUrlOne){
				window.open(value.drawingUrlOne);
		    }
	    },
		clearFileInput(inputELement){
			inputELement.value = null;
		},
	    cadExport(){
			window.open('https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/CAD%E5%9B%BE%E7%BA%B8%E5%AF%BC%E5%87%BAPDF%E6%A0%BC%E5%BC%8F%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E.mp4');
	    },
	    drawingExport(){
			window.open('https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/%E5%85%A8%E5%A5%97%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B.zip')
	    },
		drawingExport2(){
			window.open('https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/%E5%85%A8%E5%A5%97%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B2.zip')
		},
		drawingStandard(){
			window.open('https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/%E5%9B%BE%E7%BA%B8%E8%A6%81%E6%B1%82%E8%AF%B4%E6%98%8E.docx')
	    },
	    
			//下载图纸
	    downloadDrawing(child){
		    console.log(child,'chileddddddd')
			let params = {
				fileName:child.filePath.split('com/')[1],
				// projectId:this.needData.id,
			}
			generateTemporaryUrlByFileName(params).then(res=>{
					// console.log(res,'res2222222')
					window.open(res.data);
			})
	    },
			//删除图纸
	    deleteDrawing(child){
		    console.log(child,'chileddddddd')
				let params = {
					fileId:child.id,
					projectId:this.projectId,
				}
				deleteKYJCProjectFile(params).then(res=>{
					if(res.data.success){
						// 从localStorage获取数据并处理可能的null值
						const filesStr = window.localStorage.getItem('splitFiles');
						const files = filesStr ? JSON.parse(filesStr) : []; // 不存在时默认为空数组
						console.log(files, 'files');

						// 校验child及fileName是否存在，避免报错
						// if (child && child.fileName) {
						// 	// 筛选符合条件的文件
						// 	// 步骤1：提取目标名称（'(' 之前的部分），加默认值避免拆分后为空
						// 	const targetBaseName = child.fileName.split('（')[0] || '';
						// 	console.log(this.selectDeleteFiles,'selectDeleteFiles')
						// 	// 步骤2：遍历对象数组，找到「属性包含目标名称」的第一个对象
						// 	// 👉 注意：把 item.fileName 替换成你对象中实际的文件名属性（比如 item.name）
						// 	const selectFiles = this.selectDeleteFiles.filter(item =>item.name.split('.pdf')[0] === targetBaseName)
						// 	// const selectFiles = this.selectDeleteFiles.includes(child.fileName.split('(')[0]);
						// 	console.log(selectFiles, 'selectFiles');
						//
						// 	// console.log(child.fileName+'.pdf', 'child.fileName+.pdf')
						// 	// 确保this.selectFiles是数组，避免undefined导致的错误
						// 	this.selectedSplitFiles = [ ...selectFiles, ...(this.selectedSplitFiles || []) ];
						// } else {
						// 	console.warn('child或child.fileName不存在，无法筛选文件');
						// }
						
						
						console.log(this.selectedSplitFiles,'this.selectFiles')
						if(window.localStorage.getItem('drawingForm')){
							const originalData = JSON.parse(localStorage.getItem('drawingForm'));
							const originalItem = originalData.find(original => original.projectId === this.projectId);
							if (!originalItem){
								const resp = {
									projectId: this.projectId,
									boolean: true,
								}
								localStorage.setItem('drawingForm', JSON.stringify([...originalData,resp]));
							}
						}else {
							const resp = {
								projectId: this.projectId,
								boolean: true,
							}
							localStorage.setItem('drawingForm', JSON.stringify([resp]));
						}
						this.$message({
							type: 'success',
							message: res.data.message,
						});
						this.getProjectFile();
					}else{
						this.$message({
							type: 'error',
							message: res.data.message,
						});
					}
				})
	    },
			//添加图纸到childFile
	    updateChildFileById(files, file,Key,additionalData) {
		    const loading = this.$loading({
			    lock: true,
			    text: '上传中...',
			    spinner: 'el-icon-loading',
			    background: 'rgba(0, 0, 0, 0.7)'
		    });
		    console.log(additionalData,'additionalData')
		    let params = {
			    fileName: file.name.split('.pdf')[0],
			    filePath: Key,
			    fileTag: additionalData.id,
			    // folderId: [1, 2, 19].includes(additionalData.id) ?
					//     this.fileInfo[0].childFiles[0].childFiles[0].folderId+1 : this.fileInfo[0].childFiles[0].childFiles[0].folderId+2,
			    projectId: this.projectId,
			    stageId: this.fileInfo[0].stageId,
		    };
				
				if ( [21,3,4].includes(additionalData.id)){
					const childFiles = this.fileInfo[0].childFiles[0].childFiles[0].childFiles;
					const targetChild = childFiles.find(child => child.fileName.includes('消防电源及配电'));
					if (targetChild) {
						params.folderId = targetChild.id;
					}
				}
		    if ( [22,5,6,7,8,9,10].includes(additionalData.id)){
			    const childFiles = this.fileInfo[0].childFiles[0].childFiles[0].childFiles;
			    const targetChild = childFiles.find(child => child.fileName.includes('火灾自动报警系统'));
			    if (targetChild) {
				    params.folderId = targetChild.id;
			    }
		    }
		    if ( [23,11,12,13,14,15,18].includes(additionalData.id)){
			    const childFiles = this.fileInfo[0].childFiles[0].childFiles[0].childFiles;
			    const targetChild = childFiles.find(child => child.fileName.includes('消防给水和灭火设施'));
			    if (targetChild) {
				    params.folderId = targetChild.id;
			    }
		    }
		    if ( [24,16,17].includes(additionalData.id)){
			    const childFiles = this.fileInfo[0].childFiles[0].childFiles[0].childFiles;
			    const targetChild = childFiles.find(child => child.fileName.includes('防烟排烟及供暖'));
			    if (targetChild) {
				    params.folderId = targetChild.id;
			    }
		    }
		    if ( [1,2,20,25,26,27,28].includes(additionalData.id)){
			    const childFiles = this.fileInfo[0].childFiles[0].childFiles[0].childFiles;
			    const targetChild = childFiles.find(child => child.fileName.includes('建筑'));
			    if (targetChild) {
				    params.folderId = targetChild.id;
			    }
		    }
		    if ( [19].includes(additionalData.id)){
			    const childFiles = this.fileInfo[0].childFiles[0].childFiles[0].childFiles;
			    const targetChild = childFiles.find(child => child.fileName.includes('装修'));
			    if (targetChild) {
				    params.folderId = targetChild.id;
			    }
		    }
		    // if (this.isAllFile){
			  //   // params.folderId = 0;
			  //   params.fileTag = 100000000;
			  //   params.folderId = 100000000;
			  //   this.isAllFile = false;
		    // }
		    params.fileMd5 = this.fileMd;
		    console.log(this.fileMd,'filemd')
		    // Call addKYJCProjectFile with the params
		    addKYJCProjectFile(params).then(res => {
			    if (res.data.success) {
				    if(window.localStorage.getItem('drawingForm')){
					    const originalData = JSON.parse(localStorage.getItem('drawingForm'));
					    const originalItem = originalData.find(original => original.projectId === this.projectId);
					    if (!originalItem){
						    const resp = {
							    projectId: this.projectId,
							    boolean: true,
						    }
						    localStorage.setItem('drawingForm', JSON.stringify([...originalData,resp]));
					    }
				    }else {
					    const resp = {
						    projectId: this.projectId,
						    boolean: true,
					    }
					    localStorage.setItem('drawingForm', JSON.stringify([resp]));
				    }
				    this.count++;
						// this.vLoading = false;
				    // if (this.countFile === this.count){
					   
					    const fileInput = document.querySelector('input[type="file"]');
					    this.clearFileInput(fileInput);
					    setTimeout(() => {
						    
						    loading.close();
				    this.getProjectFileDebounce()
					    },1000)
				    // }
				    
			    } else {
				    loading.close();
				    this.$message({
					    type: 'error',
					    message: res.data.message,
				    });
			    }
		    });
		    
			},
				    
				    // 直接包装防抖方法
				    getProjectFileDebounce: debounce(function () {
					    this.$message({
						    type: 'success',
						    message: '上传成功！',
					    });
					    this.getProjectFile();
				    }, 2000),
				    
				    
				    //添加图纸到childFile
				   async updateChildFileByIdAll(files, file,Key,additionalData) {
					    
					    
					    let params = {
						    fileName: file.name.split('.pdf')[0],
						    filePath: Key,
						    fileTag: additionalData.id,
						    // folderId: [1, 2, 19].includes(additionalData.id) ?
						    //     this.fileInfo[0].childFiles[0].childFiles[0].folderId+1 : this.fileInfo[0].childFiles[0].childFiles[0].folderId+2,
						    projectId: this.projectId,
						    stageId: this.fileInfo[0].stageId,
					    };
					    
						    // params.folderId = 0;
						    params.fileTag = 0;
						    
					    
					    if ( [21,3,4].includes(additionalData.id)){
						    const childFiles = this.fileInfo[0].childFiles[0].childFiles[0].childFiles;
						    const targetChild = childFiles.find(child => child.fileName.includes('消防电源及配电'));
						    if (targetChild) {
							    params.folderId = targetChild.id;
						    }
					    }
					    if ( [22,5,6,7,8,9,10].includes(additionalData.id)){
						    const childFiles = this.fileInfo[0].childFiles[0].childFiles[0].childFiles;
						    const targetChild = childFiles.find(child => child.fileName.includes('火灾自动报警系统'));
						    if (targetChild) {
							    params.folderId = targetChild.id;
						    }
					    }
					    if ( [23,11,12,13,14,15,18].includes(additionalData.id)){
						    const childFiles = this.fileInfo[0].childFiles[0].childFiles[0].childFiles;
						    const targetChild = childFiles.find(child => child.fileName.includes('消防给水和灭火设施'));
						    if (targetChild) {
							    params.folderId = targetChild.id;
						    }
					    }
					    if ( [24,16,17].includes(additionalData.id)){
						    const childFiles = this.fileInfo[0].childFiles[0].childFiles[0].childFiles;
						    const targetChild = childFiles.find(child => child.fileName.includes('防烟排烟及供暖'));
						    if (targetChild) {
							    params.folderId = targetChild.id;
						    }
					    }
					    if ( [1,2,20,25,26,27,28].includes(additionalData.id)){
						    const childFiles = this.fileInfo[0].childFiles[0].childFiles[0].childFiles;
						    const targetChild = childFiles.find(child => child.fileName.includes('建筑'));
						    if (targetChild) {
							    params.folderId = targetChild.id;
						    }
					    }
					    if ( [19].includes(additionalData.id)){
						    const childFiles = this.fileInfo[0].childFiles[0].childFiles[0].childFiles;
						    const targetChild = childFiles.find(child => child.fileName.includes('装修'));
						    if (targetChild) {
							    params.folderId = targetChild.id;
						    }
					    }
					   if (this.isAllFile){
						   // params.folderId = 0;
						   params.fileTag = 100000000;
						   params.folderId = 100000000;
						   this.isAllFile = false;
					   }
					    params.fileMd5 = this.fileMd;
					    console.log(this.fileMd,'filemd')
					    // Call addKYJCProjectFile with the params
					   const resp = await addKYJCProjectFile(params)
							   
						    if (resp.data.success) {
							    this.isAllFile = false;
							   
						    } else {
							    
							    this.$message({
								    type: 'error',
								    message: resp.data.message,
							    });
						    }
					    
					    
				    },
				    
				    
	    showFile (file) {
				this.drawingUrl = file.filePathDxf;
				this.drawingDialog = true;
	    },
	    async checkPdfPages(file) {
		    try {
			    // 将File对象转换为ArrayBuffer
			    const arrayBuffer = await file.arrayBuffer();
			    
			    // 加载PDF文档
			    const pdfDoc = await PDFDocument.load(arrayBuffer);
			    
			    // 获取页面数量
			    const pageCount = pdfDoc.getPageCount();
			    
			    // 返回结果：是否多页（页数 > 1）
			    return {
				    isMultiPage: pageCount > 1,
				    pageCount: pageCount
			    };
		    } catch (error) {
			    console.error('解析PDF失败：', error);
			    // 处理解析错误（如非PDF文件、损坏的PDF等）
			    return {
				    isMultiPage: false,
				    pageCount: 0,
				    error: '无效的PDF文件或解析失败'
			    };
		    }
	    },
				 
	    uniqueByFilename(arr) {
		    const filenameMap = new Map();
		    const result = [];
		    
		    for (const obj of arr) {
			    // 取出当前对象的 filename（无则为 undefined）
			    const filename = obj.name;
			    // 仅保留首次出现该 filename 的对象
			    if (!filenameMap.has(filename)) {
				    filenameMap.set(filename, true); // 标记为已出现
				    result.push(obj);
			    }
		    }
		    
		    return result;
	    },
				 
	    // 处理文件选择
	    handleFileUpload(event, additionalData) {
				this.count = 0
		    this.countFile = 0
		    this.additionalData = additionalData
		    console.log(event,'ebeekljedklfjsdkf')
		    let files = []
		    files = [...event.target.files]; // 获取选择的文件
		    
		    // console.log(this.historyFiles,'historyFiles')
		    files.forEach(file => {
			    setTimeout(async () => {
				    if (file) {
					    const pdfInfo = await this.checkPdfPages(file);
					    
					    console.log(`文件 ${file.name} 页数：${pdfInfo.pageCount}`);
					    
					    // 根据是否多页进行处理
					    if (pdfInfo.isMultiPage&&!file.name.includes('设计专篇')) {
						    console.log('需要分页处理');
						    // cancelButtonText: '取消',
						    // this.$confirm('此文件有多页，是否进行分页处理？', '提示', {
						    // 	confirmButtonText: '确定',
						    //
						    // 	type: 'warning',
						    // }).then(async () => {
						    // 	// 确定处理
						    // 	const  list = await  this.splitPdf(file, file.name)
						    // 	console.log(list,'listttttttttttttttttttttttttt')
						    // 	this.selectedSplitFiles = [...this.selectedSplitFiles, ...list]
						    //
						    // 	window.localStorage.setItem('splitFiles', JSON.stringify(this.selectedSplitFiles));
						    // 	console.log('确定处理');
						    // 	this.splitFileDialogVisible = true;
						    // 	// 执行分页逻辑...
						    // }).catch(() => {
						    // 	// 取消处理
						    // 	console.log('取消处理');
						    // 	// 执行取消逻辑...
						    // })
						    await this.$alert('PDF文件包含多个图纸，请在对应的分类下点击选择图纸', '提示', {
							    confirmButtonText: '确定',
							    callback:async action => {
								   
										this.isAllFile = true;
								    
								    
								    const list = await this.splitPdf(file, file.name,files, additionalData)
								    
								    // const Key = 'projectFile' + '/' + this.project.projectName + this.project.projectNo + '/' + this.fileInfo[0].stageId  + file.name; // 使用文件名作为上传的Key
								    //
								    // this.uploadFile(files,file, Key, additionalData);
								    console.log(list, 'listttttttttttttttttttttttttt')
								    const arrs = [...this.selectedSplitFiles, ...list]
								    this.selectedSplitFiles = this.uniqueByFilename(arrs)
								    // window.localStorage.setItem('splitFiles', JSON.stringify(this.selectedSplitFiles));
								    console.log('确定处理');
								    this.splitFileDialogVisible = true;
							    }
						    });
						    
						    // 执行分页逻辑...
					    } else {
								this.countFile ++;
						    console.log(file, 'file')
						    if (!this.vLoading) {
							    
							    if ( [21,3,4].includes(additionalData.id)){
								    this.itemName = '消防电源及配电'
							    }
							    if ( [22,5,6,7,8,9,10].includes(additionalData.id)){
								    this.itemName = '火灾自动报警系统'
							    }
							    if ( [23,11,12,13,14,15,18].includes(additionalData.id)){
								    this.itemName = '消防给水和灭火设施'
							    }
							    if ( [24,16,17].includes(additionalData.id)){
								    this.itemName = '防烟排烟及供暖、通风和空气调节设施'
							    }
							    if ( [1,2,20,25,26,27,28].includes(additionalData.id)){
								    this.itemName = '建筑'
							    }
							    if ( [19].includes(additionalData.id)){
								    this.itemName = '装修'
							    }
							    
							    
							    const Key = 'projectFile' + '/' + this.project.projectName + this.project.projectNo + '/' + this.fileInfo[0].stageId + '/' + this.fileInfo[0].childFiles[0].fileName + '/' +
									    this.fileInfo[0].childFiles[0].childFiles[0].fileName + '/' +this.itemName + '/' + file.name; // 使用文件名作为上传的Key
							    console.log(Key, 'Key')
							    console.log(additionalData,'additionalDataiiiiiiii')
							    this.uploadFile(files,file, Key, additionalData); // 调用上传方法，并传递额外参数 this.uploadFile(file, Key, additionalData); // 调用上传方法，并传递额外参数
							    // }
						    }
					    }
					    
				    }
			    },0)
			    
		    });
		    
		   
	    },
	    // 上传文件方法
	    uploadFile(files, file, Key, additionalData) {
		    this.obsClient = new ObsClient({
			    access_key_id: process.env.VUE_APP_ACCESS_KEY_ID,
			    secret_access_key: process.env.VUE_APP_SECRET_ACCESS_KEY,
			    server: process.env.VUE_APP_SERVER_ACCESS_AREA
		    });
		    console.log(this.obsClient, 'obsClient');
		    this.uploading = true;
		    console.log('额外参数:', additionalData);
		    this.obsClient.putObject({
			    Bucket: this.Bucket,
			    Key,
			    SourceFile: file,
			    ContentType: 'application/pdf',
		    }, (err, result) => {
			    this.uploading = false;
			    if (err) {
				    console.error('上传出错:', err);
			    } else {
						if (result.CommonMsg.Status === 200){
							console.log('上传成功:', result);
							this.vLoading = false;
							// Check if fileInfo and projectId are defined
							if (this.fileInfo && this.fileInfo.length > 0 && this.projectId) {
								this.handleFileMdfive(file);
								setTimeout(()=>{
									this.updateChildFileById(files, file, Key, additionalData)
								},500)
							} else {
								console.error('必要的数据未定义：fileInfo 或 projectId');
							}
							const url = `https://${this.Bucket}.obs.${this.Area}/${Key}`;
							console.log('文件URL:', url);
						}
				   
			    }
		    });
		    
	    },
				 
	  async  uploadFileAll(files, file, Key, additionalData) {
		    this.obsClient = new ObsClient({
			    access_key_id: process.env.VUE_APP_ACCESS_KEY_ID,
			    secret_access_key: process.env.VUE_APP_SECRET_ACCESS_KEY,
			    server: process.env.VUE_APP_SERVER_ACCESS_AREA
		    });
		    console.log(this.obsClient, 'obsClient');
		    this.uploading = true;
		    console.log('额外参数:', additionalData);
		    this.obsClient.putObject({
			    Bucket: this.Bucket,
			    Key,
			    SourceFile: file,
			    ContentType: 'application/pdf',
		    }, (err, result) => {
			    this.uploading = false;
			    if (err) {
				    console.error('上传出错:', err);
			    } else {
				    if (result.CommonMsg.Status === 200){
					    console.log('上传成功:', result);
					    this.vLoading = false;
					    // Check if fileInfo and projectId are defined
					    if (this.fileInfo && this.fileInfo.length > 0 && this.projectId) {
						    this.handleFileMdfive(file);
						    setTimeout(()=>{
							    this.updateChildFileByIdAll(files, file, Key, additionalData)
						    },500)
					    } else {
						    console.error('必要的数据未定义：fileInfo 或 projectId');
					    }
					    const url = `https://${this.Bucket}.obs.${this.Area}/${Key}`;
					    console.log('文件URL:', url);
				    }
				    
			    }
		    });
		    
	    },
	    
	    
	    //添加图纸
	    addSheet( row ){
		    this.fileList.forEach(item => {
					    item.data.forEach(dataItem => {
						    if (dataItem.id === row.fileTag) {
							    dataItem.childFiles.push( {...row });
						    }
					    });
	    })
	    },
	    addDrawing(items) {
				this.drawingList = [];
		    const filteredItems = []; // 新数组，用于存放对象
		    const processItems = (items) => {
			    items.forEach(item => {
				    if (item.filePathDxf !== null) {
					    filteredItems.push(item);
				    }
				    if (item.childFiles && item.childFiles.length > 0) {
					    processItems(item.childFiles);
				    }
			    });
		    };
		    processItems(items);
		    // 你可以根据需求使用 filteredItems 数组，例如添加到 drawingList 中
		    this.drawingList.push(...filteredItems);
	    },
	    
	    //获取申报表
	    getapplication () {
		    if (this.projectId){
			    let params = {
				    projectId: this.projectId
			    }
			    getKYJCApplicationByProjectId(params).then(res => {
				    let result = res.data
				    if (result.success) {
					    let resp = result.response
						this.tableForm = resp
						this.project = resp
					    const res=resp.projectFireFacilitiesIds.split(',')
					    this.placeJsonData = []
					    this.placeJsonData=res.map(str => parseInt(str, 10));
							this.placeJsonData.forEach(item => {
								this.addSheets(item)
							})
					    console.log(this.placeJsonData,'resp')
				    }
			    })
		    }
	    },
	    //添加图纸
	    addSheets( row ){
		    this.fileList.forEach(item => {
			    item.data.forEach(dataItem => {
				    if (dataItem.id === row) {
					    dataItem.isXing = true;
				    }
			    });
		    })
	    },
	    //获取项目文件结构
	    getProjectFile(){
				this.fileList = [
					{
						name: '场所平面结构图',
						remark:'包括场地四邻原有及规划道路的位置和主要建筑物及构筑物的位置、名称、功能、层数、间距;场所所在建筑物的位置、名称、层数和消防车道及登高操作场地布置等内容；包括场所平面布置，房间功能和面积，疏散楼梯、疏散走道，消防电梯，平面或空间的防火、防烟分区面积、分隔位置和分隔物；各部位(顶棚、墙面、地面、隔断的装修材料以及固定家具、装饰织物、其他装饰等)装修材料燃烧性能等内容。',
						data:[
							{
								title:'消防设计说明（图纸设计说明以合并方式书写的可重复上传）',
								id:20,
								isXing:false,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%80%BB%E5%B9%B3%E9%9D%A2%E5%9B%BE/%E6%B6%88%E9%98%B2%E8%AE%BE%E8%AE%A1%E8%AF%B4%E6%98%8E.pdf',
							},
							{
								title:'总平面图',
								isXing:false,
								id:1,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%80%BB%E5%B9%B3%E9%9D%A2%E5%9B%BE/%E6%80%BB%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
							},
							{
								title:'楼层平面布置图',
								isXing:false,
								id:2,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%A5%BC%E5%B1%82%E5%B9%B3%E9%9D%A2%E5%B8%83%E7%BD%AE%E5%9B%BE/%E9%A6%96%E5%B1%82%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
							},
							{
								title:'场所平面布置图',
								isXing:false,
								id:28,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%A5%BC%E5%B1%82%E5%B9%B3%E9%9D%A2%E5%B8%83%E7%BD%AE%E5%9B%BE/%E5%B9%B3%E9%9D%A2%E5%B8%83%E7%BD%AE%E5%9B%BE.pdf',
							},
							{
								title:'顶棚装修平面图',
								isXing:false,
								id:25,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E8%A3%85%E4%BF%AE%E5%9B%BE/%E9%A1%B6%E6%A3%9A%E8%A3%85%E4%BF%AE%E5%9B%BE.pdf',
							},
							{
								title:'墙面装修平面图',
								isXing:false,
								id:27,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E8%A3%85%E4%BF%AE%E5%9B%BE/%E7%AB%8B%E9%9D%A2%E8%A3%85%E4%BF%AE%E5%9B%BE.pdf',
							},
							{
								title:'地面装修平面图',
								isXing:false,
								id:26,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E8%A3%85%E4%BF%AE%E5%9B%BE/%E5%9C%B0%E9%9D%A2%E8%A3%85%E4%BF%AE%E5%9B%BE.pdf',
							},
						]
					},
					{
						name: '消防电源及配电',
						remark:'包括消防供电负荷等级，消防配电线路的敷设方式，备用消防电源的供电时间和容量；包括消防应急照明和疏散指示的系统方式，配电方式及供电时间，灯具选型，照度、安装位置和高度，线路敷设方式等。',
						data:[
							{
								title:'消防电气设计说明（图纸设计说明以合并方式书写的可重复上传）',
								isXing:false,
								id:21,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%94%B5%E6%BA%90%E5%8F%8A%E9%85%8D%E7%94%B5/%E7%94%B5%E6%B0%94%E8%AE%BE%E8%AE%A1%E8%AF%B4%E6%98%8E.pdf',
							},
							{
								title:'消防配电平面图、系统图',
								isXing:false,
								id:3,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%94%B5%E6%BA%90%E5%8F%8A%E9%85%8D%E7%94%B5/%E6%B6%88%E9%98%B2%E7%94%B5%E6%B0%94%E7%B3%BB%E7%BB%9F%E5%9B%BE.pdf',
							},
							{
								title:'应急照明和疏散指示平面图、系统图',
								isXing:false,
								id:4,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%94%B5%E6%BA%90%E5%8F%8A%E9%85%8D%E7%94%B5/%E5%BA%94%E6%80%A5%E7%85%A7%E6%98%8E%E5%92%8C%E7%96%8F%E6%95%A3%E6%8C%87%E7%A4%BA%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
								drawingUrlOne:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%94%B5%E6%BA%90%E5%8F%8A%E9%85%8D%E7%94%B5/%E5%BA%94%E6%80%A5%E7%85%A7%E6%98%8E%E5%92%8C%E7%96%8F%E6%95%A3%E6%8C%87%E7%A4%BA%E7%B3%BB%E7%BB%9F%E5%9B%BE.pdf'
							}
						]
					},
					{
						name: '火灾自动报警系统',
						remark:'包括系统形式，线路的敷设方式，火灾探测器的类型及位置，手动报警按钮、消火栓启泵按钮、消防电话、火灾应急广播及消防联动控制设备位置等内容。',
						data:[
							{
								title:'消防电气设计说明（图纸设计说明以合并方式书写的可重复上传）',
								isXing:false,
								id:22,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'',
							},
							{
								title:'消防控制室位置平面图',
								isXing:false,
								id:5,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F/%E6%B6%88%E9%98%B2%E6%8E%A7%E5%88%B6%E5%AE%A4%E4%BD%8D%E7%BD%AE%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
							},
							{
								title:'火灾自动报警系统图、各层报警平面图',
								isXing:false,
								id:6,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
								drawingUrlOne:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F%E7%B3%BB%E7%BB%9F%E5%9B%BE.pdf',
							},
							{
								title:'可燃气体探测报警系统平面图、系统图',
								isXing:false,
								id:7,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F%E5%B9%B3%E9%9D%A2%E5%9B%BE-%E5%8F%AF%E7%87%83%E6%B0%94%E4%BD%93.pdf',
							},
							{
								title:'电气火灾监控系统平面图、系统图',
								isXing:false,
								id:8,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F/%E7%81%AB%E7%81%BE%E8%87%AA%E5%8A%A8%E6%8A%A5%E8%AD%A6%E7%B3%BB%E7%BB%9F%E7%B3%BB%E7%BB%9F%E5%9B%BE-%E9%9F%B3%E8%A7%86%E9%A2%91%E8%AD%A6%E6%8A%A5%E3%80%81%E7%94%B5%E6%B0%94%E7%81%AB%E7%81%BE%E7%9B%91%E6%8E%A7.pdf',
							},
							{
								title:'防火门监控系统平面图、系统图',
								isXing:false,
								id:9,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'',
							},
							{
								title:'消防设备电源监控系统图',
								isXing:false,
								id:10,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'',
							},
						]
					},
					{
						name: '消防给水和灭火设施',
						remark:'包括消防水源的供水方式，消防水泵房、消防水池、水泵接合器位置，室外消防给水系统给水管道及室外消火布置；包括室内消火栓系统给水管道及消火栓的布置；包括系统组成、控制方式，报警阀、末端试水装置位置；包括系统组成、控制方式，储瓶间位置',
						data:[
							{
								title:'消防给排水设计说明（图纸设计说明以合并方式书写的可重复上传）',
								isXing:false,
								id:23,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%BB%99%E6%B0%B4%E5%92%8C%E7%81%AD%E7%81%AB%E8%AE%BE%E6%96%BD/%E6%B6%88%E9%98%B2%E7%BB%99%E6%B0%B4%E5%92%8C%E7%81%AD%E7%81%AB%E8%AE%BE%E6%96%BD%E8%AE%BE%E8%AE%A1%E8%AF%B4%E6%98%8E.pdf',
							},
							{
								title:'消防给水总平面图，各消防给水系统的平面图、系统图',
								isXing:false,
								id:11,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%BB%99%E6%B0%B4%E5%92%8C%E7%81%AD%E7%81%AB%E8%AE%BE%E6%96%BD/%E6%B6%88%E9%98%B2%E7%BB%99%E6%B0%B4%E5%92%8C%E7%81%AD%E7%81%AB%E8%AE%BE%E6%96%BD%E7%B3%BB%E7%BB%9F%E5%9B%BE.pdf',
							},
							{
								title:'消防水池和消防水泵房平面图',
								isXing:false,
								id:12,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%BB%99%E6%B0%B4%E5%92%8C%E7%81%AD%E7%81%AB%E8%AE%BE%E6%96%BD/%E6%B6%88%E9%98%B2%E6%B0%B4%E6%B3%B5%E6%88%BF%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
							},
							{
								title:'室内消火栓系统图、各层平面图',
								isXing:false,
								id:13,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%BB%99%E6%B0%B4%E5%92%8C%E7%81%AD%E7%81%AB%E8%AE%BE%E6%96%BD/%E5%AE%A4%E5%86%85%E6%B6%88%E7%81%AB%E6%A0%93%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
							},
							{
								title:'自动喷水灭火系统的平面图、系统图',
								isXing:false,
								id:14,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%BB%99%E6%B0%B4%E5%92%8C%E7%81%AD%E7%81%AB%E8%AE%BE%E6%96%BD/%E8%87%AA%E5%8A%A8%E5%96%B7%E6%B0%B4%E7%81%AD%E7%81%AB%E7%B3%BB%E7%BB%9F%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
							},
							{
								title:'气体灭火系统的平面图、系统图',
								isXing:false,
								id:15,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'',
							},
							{
								title:'灭火器配置平面',
								isXing:false,
								id:18,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E6%B6%88%E9%98%B2%E7%BB%99%E6%B0%B4%E5%92%8C%E7%81%AD%E7%81%AB%E8%AE%BE%E6%96%BD/%E7%81%AD%E7%81%AB%E5%99%A8%E9%85%8D%E7%BD%AE%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
							},],
					},
					{
						name: '防烟排烟及供暖、通风和空气调节设施',
						remark:'包括设置防烟的区域及方式，送风口以及防火阀的位置；供暖、通风和空气调节设施的防火措施；包括设置排烟的区域及方式，送风口、排烟口以及防火阀、排烟防火阀的位置；供暖、通风和空气调节设施的防火措施。',
						data:[
							{
								title:'消防防排烟、暖通设计说明（图纸设计说明以合并方式书写的可重复上传）',
								isXing:false,
								id:24,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'',
							},
							{
								title:'防烟系统平面图、系统图（防、排烟系统以合并方式作图的可重复上传）',
								isXing:false,
								id:16,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E9%98%B2%E7%83%9F%E6%8E%92%E7%83%9F%E5%8F%8A%E4%BE%9B%E6%9A%96%E3%80%81%E9%80%9A%E9%A3%8E%E5%92%8C%E7%A9%BA%E6%B0%94%E8%B0%83%E8%8A%82%E8%AE%BE%E6%96%BD/%E9%98%B2%E6%8E%92%E7%83%9F%E5%B9%B3%E9%9D%A2%E5%9B%BE.pdf',
							},
							{
								title:'排烟系统平面图、系统图（防、排烟系统以合并方式作图的可重复上传）',
								isXing:false,
								id:17,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'https://qdzn-pro.obs.cn-east-3.myhuaweicloud.com/docs/%E5%9B%BE%E7%BA%B8%E6%A0%B7%E4%BE%8B/20241113/%E9%98%B2%E7%83%9F%E6%8E%92%E7%83%9F%E5%8F%8A%E4%BE%9B%E6%9A%96%E3%80%81%E9%80%9A%E9%A3%8E%E5%92%8C%E7%A9%BA%E6%B0%94%E8%B0%83%E8%8A%82%E8%AE%BE%E6%96%BD/%E6%9C%BA%E6%A2%B0%E6%8E%92%E7%83%9F%E7%B3%BB%E7%BB%9F%E5%9B%BE.pdf',
							}
						]
					},
					{
						name: '其他',
						remark:'包括系统组成、控制方式',
						data:[
							{
								title:'其他',
								isXing:false,
								id:19,
								button:'上传图纸',
								childFiles:[],
								drawingUrl:'',
							},
						]
					},
				]

		    let params = {
			    projectId: this.projectId
		    }
		    getKYJCProjectFileInfo(params).then(res => {
			    let result = res.data
			    if(result.success) {
				    this.fileInfo = result.response.files
				    console.log(this.fileInfo,'文件信息')
				    this.addDrawing(result.response.files)
				    setTimeout(() => {
					    this.drawingList.forEach(item => {
						    this.addSheet(item)
					    })
				    },100)
				    console.log(this.fileList,'fileList')
			    }
		    })
			this.placeJsonData = []
			const projectFireFacilitiesList=this.tableForm.projectFireFacilitiesIds.split(',')
			this.placeJsonData=projectFireFacilitiesList.map(str => parseInt(str, 10));
			this.placeJsonData.forEach(item => {
				this.addSheets(item)
			})
			console.log(this.placeJsonData,'placeJsonData')
		    
	    },
	    // 从sessionStorage初始化数据
	    initFormData() {
		    // const savedData = sessionStorage.getItem('sessionFiles');
		    // console.log(savedData,'saveddata')
		    // if (savedData) {
			  //   // 读取时转回对象
			  //   this.selectedSplitFiles = JSON.parse(savedData);
		    // } else {
			  //   // 如果没有存储数据，设置默认值
			  //   this.selectedSplitFiles = undefined;
				// }
		    // this.selectedSplitFiles = this.sessionFiles
	    },
    },
    watch: {
		'projectId': function() {
			this.vLoading = false;
			this.project = {}
			this.getProjectFile()
			if(this.placeJsonData.length < 2){
				this.getapplication()
			}
		},
	    // 深度监听formData的变化，同步到sessionStorage
	   //  selectedSplitFiles: {
		  //   handler(newVal) {
				
			 //    // 存储时转为字符串（sessionStorage仅支持字符串）
			 //    sessionStorage.setItem('sessionFiles', JSON.stringify(newVal));
		  //   },
		  //   deep: true // 深度监听对象内部属性变化
	   //  }
    },
    created(){
		
		this.project = {}
		this.getProjectFile()
		if(this.placeJsonData.length < 2){
			this.getapplication()
		}
		console.log(this.tableForm ,'tableForm')
	   
    },
	mounted() {
	
	
	}
}
</script>

<style lang="stylus" scoped>
// 添加分页文件项样式
.split-file-item {
	padding: 10px;
	border-bottom: 1px solid #eee;
	display: flex;
	align-items: center;
}

.split-file-item:last-child {
	border-bottom: none;
}
input[type="file"] {
	color: transparent;
}

.fileListItem{
	align-items:center;
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
	margin-top :10px;
	padding :5px 20px
	border: 1px solid #ccc;
}
.popperClass{
	background-color: #b9d5f5;
}
.el-popover{
	padding :0
	background-color :#b9d5f5;
}

.itemList{
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
	background-color: #dcdbdb;
	align-items: center;
	height: 40px;
}
.circle-button {
	font-weight: bold;
	font-size: 18px;
	background-color: #b9d5f5;
	border-radius: 50%;
	width: 25px;
	height: 25px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-left: 8px;
	padding-bottom :8px
	margin-top :5px
}
    .timerSty {
        width: 100px;
    }
    .noTimerSty {
        margin-left: 20px;
    }
    .areaSty {
        width: 300px;
        margin-right: 2px;
    }
    .dialogTitle {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
    }
    .activeSty {
        margin-top: 10px;
    }
    .activeSty .el-form-item {
        margin-bottom: 0px;
    }
    .titleSpeSty {
        font-weight: bold;
    }
    .spacilTimer>>>.el-form-item__label {
        color: red!important;
        font-weight: bold;
    }

    .project-notes {
      white-space: pre-wrap; /* 保留换行符并允许文本自动换行 */
      word-wrap: break-word; /* 在长单词或URL换行 */
    }
</style>
